import Vue from "vue";
import VueRouter from "vue-router";
import qRouter from "./qRouter.js";
import hRouter from "./hRouter.js";
import pRouter from "./pRouter.js";

Vue.use(VueRouter);

const routes = [
  ...qRouter,
  ...hRouter,
  ...pRouter,
  {
    path: "/login",
    name: "Login",
    meta: { title: "登录" },
    component: () => import("@/views/login"),
  },
  {
    path: "/home",
    name: "Home",
    meta: { title: "我的桌面" },
    component: () => import("@/views/desktop"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: routes,
});

export default router;
